import React, { memo } from 'react';
import Animated, { interpolateColor, useAnimatedStyle, } from 'react-native-reanimated';
import { Text, View } from 'react-native';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import Spacer from './Spacer';
import { rem } from './values';
import { SEARCH_BAR_HEIGHT } from './SearchBar';
import IconSearch from './icons/IconSearch';
const FakeSearchBar = ({ style, scrollY, placeholder = 'Search', }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const bgColorStyle = useAnimatedStyle(() => ({
        backgroundColor: !scrollY
            ? colors.cards.onDark
            : interpolateColor(scrollY.value, [0, 40], [
                colors.cards.onDark,
                colors.background.dark,
            ]),
    }), [colors]);
    return (<View pointerEvents="none" style={[styles.container, styles.marginBottom, style]}>
      <Animated.View style={[styles.searchBar, scrollY && bgColorStyle]}>
        <IconSearch />
        <Spacer w={8}/>
        {/* Text rather than a TextInput: the bar never takes input. */}
        <Text style={styles.placeholder} numberOfLines={1}>
          {placeholder}
        </Text>
      </Animated.View>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        marginTop: rem(8),
        paddingHorizontal: rem(16),
    },
    marginBottom: {
        marginBottom: rem(16),
    },
    searchBar: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: rem(12),
        height: SEARCH_BAR_HEIGHT,
        paddingHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
    },
    placeholder: {
        flexShrink: 1,
        fontFamily: 'Montserrat-Light',
        fontSize: rem(16),
        color: colors.text.placeholder,
    },
}));
export default memo(FakeSearchBar);
